export const productGroupsAltLangModalLanguage = {
    en: {
        title: 'Alternative Display Language',
        ok: 'OK',
        cancel: 'Cancel',
        placeholder: 'Enter alternative name'
    },
    th: {
        title: 'ชื่อแสดงผลทางเลือก',
        ok: 'ตกลง',
        cancel: 'ยกเลิก',
        placeholder: 'ป้อนชื่อทางเลือก'
    },
    cn: {
        title: '替代显示语言',
        ok: '确定',
        cancel: '取消',
        placeholder: '输入替代名称'
    },
    jp: {
        title: '代替表示言語',
        ok: 'OK',
        cancel: 'キャンセル',
        placeholder: '代替名を入力してください'
    },
    kr: {
        title: '대체 표시 언어',
        ok: '확인',
        cancel: '취소',
        placeholder: '대체 이름 입력'
    }
}

export const productGroupsAppearanceLanguage = {
    en: {
        NoImage: 'No Image',
        UploadImage: 'Upload Image',
        RemoveImage: 'Remove Image',
        ButtonColor: 'Button Color',
        ButtonFontSize: 'Button Font Size',
        XLarge: 'X-Large',
        Large: 'Large',
        Medium: 'Medium',
        Small: 'Small',
        Red: 'Red',
        Green: 'Green',
        Blue: 'Blue',
        Yellow: 'Yellow',
        Cyan: 'Cyan',
        Magenta: 'Magenta',
        Orange: 'Orange',
        Purple: 'Purple',
        Brown: 'Brown',
        Pink: 'Pink',
        Lime: 'Lime',
        Teal: 'Teal',
    },
    th: {
        NoImage: 'ไม่มีรูปภาพ',
        UploadImage: 'อัปโหลดรูปภาพ',
        RemoveImage: 'ลบรูปภาพ',
        ButtonColor: 'สีปุ่ม',
        ButtonFontSize: 'ขนาดตัวอักษรปุ่ม',
        XLarge: 'ขนาดใหญ่มาก',
        Large: 'ขนาดใหญ่',
        Medium: 'ขนาดกลาง',
        Small: 'ขนาดเล็ก',
        Red: 'แดง',
        Green: 'เขียว',
        Blue: 'น้ำเงิน',
        Yellow: 'เหลือง',
        Cyan: 'ฟ้า',
        Magenta: 'ม่วงแดง',
        Orange: 'ส้ม',
        Purple: 'ม่วง',
        Brown: 'น้ำตาล',
        Pink: 'ชมพู',
        Lime: 'เขียวอ่อน',
        Teal: 'เขียวอมฟ้า',
    },
    cn: {
        NoImage: '无图片',
        UploadImage: '上传图片',
        RemoveImage: '移除图片',
        ButtonColor: '按钮颜色',
        ButtonFontSize: '按钮字体大小',
        XLarge: '特大',
        Large: '大',
        Medium: '中',
        Small: '小',
        Red: '红色',
        Green: '绿色',
        Blue: '蓝色',
        Yellow: '黄色',
        Cyan: '青色',
        Magenta: '品红',
        Orange: '橙色',
        Purple: '紫色',
        Brown: '棕色',
        Pink: '粉色',
        Lime: '酸橙色',
        Teal: '蓝绿色',
    },
    kr: {
        NoImage: '이미지 없음',
        UploadImage: '이미지 업로드',
        RemoveImage: '이미지 제거',
        ButtonColor: '버튼 색상',
        ButtonFontSize: '버튼 글꼴 크기',
        XLarge: '특대',
        Large: '대',
        Medium: '중',
        Small: '소',
        Red: '빨강',
        Green: '초록',
        Blue: '파랑',
        Yellow: '노랑',
        Cyan: '청록',
        Magenta: '마젠타',
        Orange: '주황',
        Purple: '보라',
        Brown: '갈색',
        Pink: '분홍',
        Lime: '라임',
        Teal: '청록색',
    },
    jp: {
        NoImage: '画像なし',
        UploadImage: '画像をアップロード',
        RemoveImage: '画像を削除',
        ButtonColor: 'ボタンの色',
        ButtonFontSize: 'ボタンのフォントサイズ',
        XLarge: '特大',
        Large: '大',
        Medium: '中',
        Small: '小',
        Red: '赤',
        Green: '緑',
        Blue: '青',
        Yellow: '黄',
        Cyan: 'シアン',
        Magenta: 'マゼンタ',
        Orange: 'オレンジ',
        Purple: '紫',
        Brown: '茶色',
        Pink: 'ピンク',
        Lime: 'ライム',
        Teal: 'ティール',
    },
}

export const productGroupsBasicLanguage = {
    en: {
        GroupName: 'Group Name',
        DisplayOrder: 'Display Order',
        Menu: 'Show on Menu',
        Order: 'Used to Route Orders',
        Threshold: 'Threshold',
        NonDiscountable: 'Non-Discountable',
        NonSurchargeable: 'Non-Surchargeable',
        AlternativeDisplayLanguage: 'Alternative Display Language',
    },
    jp: {
        GroupName: 'グループ名',
        DisplayOrder: '表示順序',
        Menu: 'メニューに表示',
        Order: '注文ルーティングに使用',
        Threshold: 'しきい値',
        NonDiscountable: '割引不可',
        NonSurchargeable: '追加料金不可',
        AlternativeDisplayLanguage: '代替表示言語',
    },
    th: {
        GroupName: 'ชื่อกลุ่ม',
        DisplayOrder: 'ลำดับการแสดงผล',
        Menu: 'แสดงในเมนู',
        Order: 'ใช้ในการจัดเส้นทางคำสั่ง',
        Threshold: 'เกณฑ์',
        NonDiscountable: 'ไม่สามารถลดราคาได้',
        NonSurchargeable: 'ไม่สามารถเรียกเก็บค่าธรรมเนียมเพิ่มเติมได้',
        AlternativeDisplayLanguage: 'ชื่อแสดงผลทางเลือก',
    },
    cn: {
        GroupName: '组名',
        DisplayOrder: '显示顺序',
        Menu: '在菜单上显示',
        Order: '用于订单路由',
        Threshold: '阈值',
        NonDiscountable: '不可折扣',
        NonSurchargeable: '不可附加费用',
        AlternativeDisplayLanguage: '替代显示语言',
    },
    kr: {
        GroupName: '그룹 이름',
        DisplayOrder: '표시 순서',
        Menu: '메뉴에 표시',
        Order: '주문 라우팅에 사용',
        Threshold: '임계값',
        NonDiscountable: '할인 불가',
        NonSurchargeable: '추가 요금 불가',
        AlternativeDisplayLanguage: '대체 표시 언어',
    },
}

export const productGroupsDetailsLanguage = {
    en: {
        GroupDetail: 'Group Detail',
        NavigationLinks: 'Navigation Links',
        Appearance: 'Appearance',
        ModifySave: 'Modify / Save',
        Delete: 'Delete',
        AreYouSure: 'Are you sure?',
        NotRevert: "You won't be able to revert this!",
        Confirm: 'Confirm',
        Deleted: 'Deleted!',
        DeletedMsg: 'Your file has been deleted.',
        Success: 'Success!',
        UpdateSuccess: 'Group details updated successfully',
    },
    th: {
        GroupDetail: 'รายละเอียดกลุ่ม',
        NavigationLinks: 'ลิงก์นำทาง',
        Appearance: 'ลักษณะ',
        ModifySave: 'แก้ไข / บันทึก',
        Delete: 'ลบ',
        AreYouSure: 'คุณแน่ใจหรือไม่?',
        NotRevert: 'คุณจะไม่สามารถย้อนกลับได้!',
        Confirm: 'ยืนยัน',
        Deleted: 'ลบแล้ว!',
        DeletedMsg: 'ไฟล์ของคุณถูกลบแล้ว',
        Success: 'สำเร็จ!',
        UpdateSuccess: 'อัปเดตรายละเอียดกลุ่มสำเร็จ',
    },
    cn: {
        GroupDetail: '组详情',
        NavigationLinks: '导航链接',
        Appearance: '外观',
        ModifySave: '修改 / 保存',
        Delete: '删除',
        AreYouSure: '你确定吗？',
        NotRevert: '此操作无法撤销！',
        Confirm: '确认',
        Deleted: '已删除！',
        DeletedMsg: '您的文件已被删除。',
        Success: '成功！',
        UpdateSuccess: '组详情更新成功',
    },
    jp: {
        GroupDetail: 'グループ詳細',
        NavigationLinks: 'ナビゲーションリンク',
        Appearance: '外観',
        ModifySave: '修正 / 保存',
        Delete: '削除',
        AreYouSure: 'よろしいですか？',
        NotRevert: 'この操作は元に戻せません！',
        Confirm: '確認',
        Deleted: '削除されました！',
        DeletedMsg: 'ファイルが削除されました。',
        Success: '成功！',
        UpdateSuccess: 'グループ詳細が正常に更新されました',
    },
    kr: {
        GroupDetail: '그룹 세부정보',
        NavigationLinks: '네비게이션 링크',
        Appearance: '외관',
        ModifySave: '수정 / 저장',
        Delete: '삭제',
        AreYouSure: '확실합니까?',
        NotRevert: '이 작업은 되돌릴 수 없습니다!',
        Confirm: '확인',
        Deleted: '삭제됨!',
        DeletedMsg: '파일이 삭제되었습니다.',
        Success: '성공!',
        UpdateSuccess: '그룹 세부정보가 성공적으로 업데이트되었습니다',
    },
}

export const productGroupsListLanguage = {
    en: {
        Add: 'Add',
        Departments: 'Departments',
    },
    th: {
        Add: 'เพิ่ม',
        Departments: 'แผนก',
    },
    cn: {
        Add: '添加',
        Departments: '部门',
    },
    jp: {
        Add: '追加',
        Departments: '部門',
    },
    kr: {
        Add: '추가',
        Departments: '부서',
    },
}

export const productGroupsModalLanguage = {
    en: {
        NewProductGroup: 'New Product Group',
        GroupName: 'Group Name',
        GroupNamePlaceholder: 'Group Name',
        OK: 'OK',
        Cancel: 'Cancel',
    },
    th: {
        NewProductGroup: 'กลุ่มสินค้าใหม่',
        GroupName: 'ชื่อกลุ่ม',
        GroupNamePlaceholder: 'ชื่อกลุ่ม',
        OK: 'ตกลง',
        Cancel: 'ยกเลิก',
    },
    cn: {
        NewProductGroup: '新产品组',
        GroupName: '组名',
        GroupNamePlaceholder: '组名',
        OK: '确定',
        Cancel: '取消',
    },
    jp: {
        NewProductGroup: '新しい商品グループ',
        GroupName: 'グループ名',
        GroupNamePlaceholder: 'グループ名',
        OK: 'OK',
        Cancel: 'キャンセル',
    },
    kr: {
        NewProductGroup: '새 제품 그룹',
        GroupName: '그룹 이름',
        GroupNamePlaceholder: '그룹 이름',
        OK: '확인',
        Cancel: '취소',
    },
}

export const productGroupsNavLinksLanguage = {
    en: {
        Departments: 'Departments',
        ProductGroups: 'Product Groups',
    },
    th: {
        Departments: 'แผนก',
        ProductGroups: 'กลุ่มสินค้า',
    },
    cn: {
        Departments: '部门',
        ProductGroups: '产品组',
    },
    jp: {
        Departments: '部門',
        ProductGroups: '商品グループ',
    },
    kr: {
        Departments: '부서',
        ProductGroups: '제품 그룹',
    },
}